import React, {Component} from "react"
import PropTypes from "prop-types"
import {Link} from "react-router"
import {Button, Col, Row} from "elemental"
import {translate} from "translate"

import "../util.scss"

class CheckoutLayout extends Component {
  render() {
    return (
      <div>
        <div id="page-wrap"
             className="wrapper-wide ">
          <div className="container-fluid top-bar ">
            <div className="container">
              <Row>
                <Col>
                  <div className="pull-left">
                    <Link to="/"><Button type="link"><i className="icon-angle-left"/> {translate("shop.continue_shopping")}</Button></Link>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <div id="page-container">
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }
}

CheckoutLayout.propTypes = {
  children: PropTypes.any
}


export default CheckoutLayout



// WEBPACK FOOTER //
// ./src/layout/CheckoutLayout.js